import { MessageResponseDto } from "@api/api";

export function isBookingLimitAllowed(response: MessageResponseDto) {
  const data = response.data as unknown;
  if (data === true || data === 1 || data === "true") {
    return true;
  }

  if (typeof data === "object" && data !== null) {
    const normalized = data as Record<string, unknown>;
    if (
      normalized.allowed === true ||
      normalized.isAllowed === true ||
      normalized.result === true ||
      normalized.value === true
    ) {
      return true;
    }
  }

  if (response.message?.toLowerCase() === "true") {
    return true;
  }

  return false;
}

export function getBookingLimitMessage(response: MessageResponseDto) {
  const data = response.data as unknown;
  if (typeof data === "string" && data.trim()) {
    return data;
  }

  if (typeof data === "object" && data !== null) {
    const normalized = data as Record<string, unknown>;
    const message = normalized.message;
    if (typeof message === "string" && message.trim()) {
      return message;
    }
  }

  if (response.message && response.message.toLowerCase() !== "true") {
    return response.message;
  }

  return "";
}
